// 定义埋点混入
const webBuryPoint = {
  data () {
    return {
      events: [],
      serverUrl: 'YOUR_SERVER_URL',
      initialized: false
    }
  },
  mounted () {
    var self = this
    window.addEventListener('beforeunload', function (event) {
      if (event.currentTarget.performance.navigation.type === 1) {
        self.closePage('refreshClose')
      } else {
        self.closePage('webclose')
      }
    })

    // 首次进入页面有问题 需要判断
    // if (!this.initialized) {
    //   this.trackPageView('')
    //   this.initialized = true
    // }
  },
  methods: {
    // 获取公共参数
    commonParam (paramLs, type = 'in') {
      // 时间
      var loadPageStartTime = ''
      if (paramLs.loadPageStartTime !== '' && paramLs.loadPageStartTime !== undefined) {
        loadPageStartTime = paramLs.loadPageStartTime
      }
      var loadPageEndTime = ''
      if (paramLs.loadPageEndTime !== '' && paramLs.loadPageEndTime !== undefined) {
        loadPageEndTime = paramLs.loadPageEndTime
      }
      var pageClickTime = ''
      if (paramLs.pageClickTime !== '' && paramLs.pageClickTime !== undefined) {
        pageClickTime = paramLs.pageClickTime
      }
      var clickData = ''
      if (paramLs.clickData !== '' && paramLs.clickData !== undefined) {
        clickData = paramLs.clickData
      }
      // 请求 返回等
      var request = ''
      if (paramLs.request !== '' && paramLs.request !== undefined) {
        request = paramLs.request
      }
      var result = ''
      if (paramLs.result !== '' && paramLs.result !== undefined) {
        result = paramLs.result
      }
      var response = ''
      if (paramLs.response !== '' && paramLs.response !== undefined) {
        response = paramLs.response
      }
      var pageType = ''
      if (paramLs.pageType !== '' && paramLs.pageType !== undefined) {
        pageType = paramLs.pageType
      }
      var pageTypeExt = ''
      if (paramLs.pageTypeExt !== '' && paramLs.pageTypeExt !== undefined) {
        pageTypeExt = paramLs.pageTypeExt
      }
      var paramType = ''
      if (paramLs.type !== '' && paramLs.type !== undefined) {
        paramType = paramLs.type
      }
      var page = ''
      if (paramLs.page !== '' && paramLs.page !== undefined) {
        page = paramLs.page
      }
      var pageSource = ''
      if (paramLs.page_source !== '' && paramLs.page_source !== undefined) {
        pageSource = paramLs.page_source
      }
      var outPageTime = ''
      if (paramLs.outPageTime !== '' && paramLs.outPageTime !== undefined) {
        outPageTime = paramLs.outPageTime
      }
      var inPageTime = ''
      if (paramLs.innterPageTime !== '' && paramLs.innterPageTime !== undefined) {
        inPageTime = paramLs.innterPageTime
      }

      //
      // var url = new URL(window.location.href)
      // 解析 URL 参数
      // var params = new URLSearchParams(url.search)
      var source = this.common.linkQuerys.source
      if (source === '' || source === undefined || source === null) {
        source = localStorage.getItem('source')
      }
      if (source === '' || source === undefined || source === null) {
        source = 'roompai'
      }

      // user_token
      var useragent = navigator.userAgent
      // console.log('浏览器设备信息为: ' + useragent)
      // console.log('屏幕分辨率为: ' + window.screen.width + 'x' + window.screen.height)
      // console.log('浏览器语言为: ' + navigator.language || navigator.userLanguage)

      // 用户 token
      var roompaiStorageToken = localStorage.getItem('roompaiStorageToken')
      // 异常 token 清除（这些 token 有问题）
      var tokenError = ['404cb56274221638d497e5dc2e7931d5', 'e59667ff4730ea107651b79bfadb4997', 'babf0e7fadeb67ac8072259c959a8c95', 'c8c88a83d7e323f87464b6020545da2b', '31a88f4f3f387ee74772b644b301509d', 'f5788a0af786c49fad89d9f8cee89a4a', 'da275bbc7ed38665d91e5afd2fcd5e9c', '3c93bf3f53905f84db6fd299afad0b3e', '5dd4c59da3333bc3a3d42c3accf6032a', '60265cf740c1bc14eb535714b373b414', 'ffc28b53e3a7f8fad5d2b0a3e46dfae8', '78cdc6503bdebfc5c0e98c14745093fd', '43544f0c81a090558dc27390694769b1', '06ecf6541375ed0738abc6ed24e35b78', 'a2032fc0aaf8e95527b68f67d8e89412', '11cc3ac1615469c53afc4ceb749e8ed7', '0c54e360ced89b378464f96dd40cec8c', '0beab46dcb616c81024f4d9b7e4e0b30', 'fd8ad29c5415b96f9edae99d32a5bb72', '9463ce1cd7731bb0f730a0f26607d2dc', '8f78e68cb103b935fb7ca5acddcfada0', 'e84d5dcf1c54e582b0aa84642a26193c', '3ab19653f9e2d70e5ddb8ba50a8979ff', '612bac422ecda9f546a217e5310bd4fc', '04fb75dd4c21bdeea6a1e74b6de970af', '0c4ed65681a599f3e35f8baf3ba87f5d', '27cbdb7e2ce83b23b7f7b6afb3bb714c', 'd4b4b787ecb00ee0682c9ee34fcf7255', '77d14785c087bfec94cd533ea6d0a7d5', 'e9d6a2b077cec29f8e99f13d512e9c53', 'ef20d4e18e88df20c4ba7610f1b6d92d', '4310aea117b0f8993e69474dcbb6cdb9', 'd7d33c5d27c432e5952f4fd251dd0907', 'da471cf5f762527398381a85a61d21f8', '4c9c7df88604dc1a888a18bba9790140', '964e0a53ac107233c450921b6bcc20ef', '51b12004f1594f9c7e84545b32991c02', '40747c4b6a713f8adf4169d54ed397bb', 'a42161479b7cc9bee894cf5666e2283c', '2cfbb89b5b4b284b139187e93a571c5f', 'f1f6b29a6cc1f79a0fea05b885aa33d0', '08d2e64839f5f5be6b5b541e64e8f8d4', '17062fabc265edef86682de9748a05e0', '97e6cd3be0ba7c6112e5bfeface7bec3', 'fdd2ba4421efe654753f778d8043d544', 'abaa6a5da74627eb2272804139cd5e4a', '19e350785776ac3c4c2efc4ae08ba1c7', '831cda93571a6a0ffa6873f84913121e', 'cbf7946eca416163693b3df8578d3f29', 'b1589f22e561db64869988aa66bb9fb3', 'fda9ade7eec3915ebecaaa6df8712f08', '1c54bbb67dfb90f9f96e565f941c0f83', '45787621586262394e05e765e116e566', '4355e917423cadf894833f03efa36503', 'd853e7ca2dea16626c4773c9e7692c30', 'cb7d104b799e773a0efe108f489ee78f', 'b9cbd8dc13f19f9e7eb854f472bfa274', '59504d7ec159d72106bc8b829fc0979b', 'e67b190ef90f2902e033f33eb1e8ac32', '62a5650fb9720d9a38014859d48836da', 'ff7e7f203dcbfae3c2289c78cf5e6085', '5eb169482eb1747e2b4e480548f6a0ee', '89e5bdfa30dee1d5d270878d2413548d', 'b1147134fc2227eb5598b358ef164f73', 'ef89860212d9266614a06354f59763dc', '2907220dca0e2bda9812e862cb4ab7f2', '4fc7a3232a6643662ca588937181636f', '4b6da9202564c7173b502922cb3d448d', '93be5d4323b9dd770a799b3d5faf6a59', 'b33dc345895b77dd46ad78ad7d44280a', '650e4298a9105b11b3ea7a4f9d15187d', '224a1a603d6312e1eda24c3c62a44dbd', '88e1dfb38af76b1a363457da0547f43e', 'fa5e083bdf3555bc08e722f6364ba63d', 'f981dd2164895fca9576214ea5750ede', '6702eb27859e521cb2a67183ed84e365', 'bdae01724b7f9dea784da6c8fc6a7b8c', '8f6b51a36078c08d3ccd4deefba00e15', '89e7fe9464a584916d75bdccbaf03972', 'b0e71aae32cb4f3d83575f5e8d90ec3b', '2ac9ab97b220af8e6781e10ea87984c2', 'f69355e1909c6253e359a56c2309f615', '913a2dd7d69a258d6765e297e618ed38', 'd77aa6b20f9449d05793e42a2abefb37', '06e9c3bda6c75024e9194d5c5e20fc7e', 'aa1b73a91800fd4793b0d5ce4ed9fbee', '7d8c88a429e645a118a24ba417af9449', 'ec8c936136150844c6d12856ff49c7cc', '07c087aa4408c85dea8230df16663edf', 'b1bc705d1ef787cc8b49457f6870bc9e', '4a0d4b20148f59b9b158f8aca6867cd0', 'acd438bf63a7438565642b29680aefcd', 'a7031849ec1738a1af1b8c5dca682c72', '7ba35013845b9808ec7a16590a263ad8', '98760ae24b4517a176142bbfa0e3c03a', '76bf44bde26b9512dd8d569d58921c93', 'f3d23fac626f9d0b8cadbb5e3acd6d94', 'eed5e0b92d501babdaa48dc74718b653', '0972d1eae3548df26497bee69414688e', '4e130fb2eac7d40b9c8e07fece0decf6', '5bead3a06085d6babcc8a1cb991283be', '8af14ce91e05037ce733372ea45f9ea7', '6d6841efc829be6178ab0d19ca48cc73', '0e24da7d4e447f50a9eb9fb4da7fcceb', '8ce9d26ec225638fff3d3e78812c9014', 'd6a2eb4553e092acd7a303c5abd46717', '4c998e5f5ff75020ed6dad16881af41d', '1b5f43fc1e71b4b7a5bd18a498e22b3c', '208d0003bc6cfe83a15be523ebd8038f', 'f273dad1289b7bfd1a9be6376813b922', 'f128d6447c0ea41b0925b12b6fd13f96', '28e22938fc3444e289c604337af4f2f7', '362d7fe3d8b2581bffa359f0eeda7106', '489b21fe26b9a7201442b775a1793484', 'f12c43acc3fb2461d65b96d3d43e9dac', 'fde6b5e09d017489a44967c1846dcc29', 'c40e89c72ad18d371a8d83597bdba4eb', 'd7b2d0654b280980af0d6e00f1372085', '7b301eac25fab8091407d279391d8121', 'dbdfa417d2d0a0680f9846c60c66f402', '3b3b9a82d397edebbd62e5bc6ec493a4', '451098578ed46f13823a445d1e4b2ddd', '817a1e253a6ecca309f489d1e8694944', 'f09d68b1ba56675af0849b83932e30a9', '6ddd3bd3fa96acbbdf43c995010802f3', 'fdecccce342f475b9299add9c108c546', '353455981630100c61ba510c3e8fcf22', 'c25bdd607a2662e087768a0fb22c06e0', '0b3f648d559345832e74d496c8d7e60e', 'f18e0860226dce2924ba63bb1298fc77', 'e667be4f36a7ef1f05618c877fea865d', 'c312b0c9bca5e403e3bbd830f04a2830', '8321855991888b483c1b79b04733cd28', '5df315818410be819a62fc5cc1cf87f9', 'fbd739345458db3340c9f932cb3aaeae', '73b943068053e1d90d5c21e64adf5df8', '9e5b4250569d4ab806a362dcbe7d0060', '44aa570a5c75d8d7af7164fd1ab153f8', '223ca34904021de8cbba87f52890d1b3', 'f6ec7b5ff4f3230309147d01e85770e4', '516148701e5400f41612a30a0a652fb9', '3150674f3345c5837f3ef2ea49ac616d', 'f5071d32d2900333014b0b24ee9914f5', 'c9c0111f54caa00af6fd4ba3881de2ba', '76f0d996c7959ea9f72a901522632d1c', 'b17873e636bc67b013b6e84c24812339', '2aad5ba313bb26a52733bcbed821ca68', '0b569451389f94474e4013065ba462af', '35ff29cbff826a69815cfe404d36fb54', '31cd911b5c5d80719bf1eee567e078c5', 'd83b7b861dde0ed4e380af77a428583d', '19b7366e625090690488d5755193dc05', '84d2626b9c28c6c48d2dccdd82247e18', 'ffe53fb60c86dfb969b6cf9c5e5fc92b', 'aeca45d1a3b35e84ce2fb75820ac9120', '6ce204927c1fcb22fe70c49dd704b469', '5a115d580e779e5c9e91989b09fbdcec', '8e5159ea5351002bd6403115d31b3313', 'd75d6d060cee12bafe91eb0a2a4bdb48', 'a5a8d63db9664d66d6078406e9878b3a', 'd948ce78bb9974ed859c917fda49deea', '96016868f516b91517c0d30768977c06', '9119780d61c4d944be1e9f60acc3c0e1', '933cb1ffcda21912b38d803b9b249319', 'ca1cd1e4ce748d55522b9e6b1f566573', '118d591e0277d91c557ebb37c269de48', '1f3f8a09ec709af22eca1e241b832510', '4628adfa118f4b2432093f7897e5e076', 'b8f129082bbfdc323b912e69bdd7bfdd', 'ce21ce9aeb72b6a466da9d64c15c69cd', '79ae4f322001818d3c36ad97000b97ba', '5b390d01a7a4cf622111375cefd1ba7e', '9a2f823bdcf8893d2432c770a1c212b4', '37018213facc68752f22eb42254cd2a0', '8e96c45f268bbbeb40fb3bb3e56552a1', '890690f3efbf74ac451352352edf885f', 'f95fb377fd78aef8cbef518777dec883', '73c5f24b8932805eae779123e25c6e3c', 'c50c9be8df0938f5e3589a98efedaf51', '644a97bdc57357ee3661845dc009c1d5', '7e027a3addee67cddbfc6e68d5517502', '63e8d8fa30c1a7ce522b9e9168a644d2', '60f33287c6d8a3b225ba473be362ced4', 'fe542d179aca017440940446410b3542', 'c89a25efdb0dd797a32c6ba95089fe46', 'ee36ed01b00ef9e78aa6e1804c40140a', '792fdb885d5a8fbd81ed310754a56cb7', '6de181831c0b673af750115dbca18bf7', '0d91bba5725f5f3a206917ff05a7460d', '6563a7f6e395224223b8e44e0ba5609a', '5114ad65179dc59039a5447cc0f98191', 'f85bbc6b10c5a4be96b5be6401baf628', 'a87a021194d8e3ee682c221812931206', 'c831a6954bae27167561a95e69e5add6', 'd8eac095bbaf20278303ff015e03d96c', 'e80899b96969756182bb1dcaa7ccf73d', 'cd35034bf415d6de8bc52e74b51b9030', '084e0e4b4b0e7e59ca0e2ac9a554fca5', '7c08d34f15d2a5ce43321ec1af0d8a2f', 'e423766eafcaaa9adb830055df0dee6b', '5cd12a45e090cdf30b52cc42bf140956', '591556d6d7a9a29fcf1f39a532d09f57', '9f512b698993ade794df3ce46b81caec', '45058c5708fb6dcad579ad2a481f87bc', 'e041fd6a0fd8f057180c6a79b986361d', '7eb1f6e70896231a429a1c8386a4905f', '5cd02939bab2564434925c3a7fa80c95', 'c4479b3fc003384c46e3d147afab2164', '65774de22ca14b2892bc86917fd67c5e', '440fcef5d5590f41f17a86fb54dccf9f', '4699c063c0dcbd7164e359a202ffcc5a', '2eac59b8addceb17b4d4adb922f675bb', '0549ebb853b6e24e1284b901fd1a2b16', '3a7a1f13f8fa0972f1ce0754ba892b9a', '591244a00b90032c27314e44a5cf2f91', '23ff5d68b38e45d749a23cec6be20225', 'c1a313f86420a23202bd08d7647c7530', '229a2a37deb8a8bd17d4061b40d2c68c', 'b0fa6fe46373a18fef32a3556c0159df', '96763cf16d5440b5b72cb34d329bb046', 'fccd47c5f082828437723cba23e6f87c']
      if (tokenError.includes(roompaiStorageToken)) {
        localStorage.removeItem('roompaiStorageToken')
        roompaiStorageToken = null
      }

      if (roompaiStorageToken === null || roompaiStorageToken === undefined) {
        var md5DataTime = parseInt(new Date().getTime())
        roompaiStorageToken = this.$md5(useragent + md5DataTime)
        localStorage.setItem('roompaiStorageToken', roompaiStorageToken)
      }

      // 识别码
      var IdentificationCode = this.IdentificationCode()

      // 用户设备等信息
      var usInfo = this.common.encryptionData({}, this)
      var client = (usInfo.flag === 'mobile') ? 'mobile' : 'pc'

      // 上一个页面
      var pageInfoData = sessionStorage.getItem('pageInfoData')
      if (pageInfoData !== '{}' && pageInfoData !== null) {
        var pageInfoArr = JSON.parse(pageInfoData)
        page = pageInfoArr.toPage
      }
      if (page === '') {
        page = this.$router.currentRoute.name
      }

      // 如果是进入页面 需要把进入页面时间记录下来
      if (type === 'in') {
        if (pageInfoData !== '{}' && pageInfoData !== null) {
          pageInfoArr = JSON.parse(pageInfoData)
          pageInfoArr.inPageTime = paramLs.innterPageTime
          var pageInfoJson = JSON.stringify(pageInfoArr)
          sessionStorage.setItem('pageInfoData', pageInfoJson)

          if (pageInfoArr.fromPage !== '' || pageInfoArr.fromPage !== null) {
            pageSource = pageInfoArr.fromPage
          }
        }
      }

      if (type === 'data') {
        if (pageInfoData !== '{}' && pageInfoData !== null) {
          pageInfoArr = JSON.parse(pageInfoData)
          inPageTime = pageInfoArr.inPageTime
        }
      }

      // 离开页面 需要 读取 离开时间
      if (type === 'out') {
        if (pageInfoData !== '{}' && pageInfoData !== null) {
          pageInfoArr = JSON.parse(pageInfoData)
          inPageTime = pageInfoArr.inPageTime
        }
        if (inPageTime === undefined || inPageTime === null) {
          inPageTime = ''
        }
      }

      // 语言 货币 站点
      var language = this.common.languageSet()
      var currency = this.common.currencySet()
      var site = this.common.siteSet()

      var ext = {
        'skip_url': window.location.href
      }

      var data = {
        'source': source,
        'IdentificationCode': IdentificationCode,
        'user_token': roompaiStorageToken,
        'page': page,
        'client': client,
        'useragent': useragent,
        // 'platform': '',
        // 'platfrom_version': '',
        // 'browser': '',
        // 'ip': '',
        // 'country': '',
        // 'province': '',
        // 'city': '',
        // 'district': '',
        // 'street': '',
        // 'create_time': '',
        'page_source': pageSource,
        'type': paramType,
        'language': language,
        'currency': currency,
        'website': site,
        'request': request,
        'result': result,
        'response': response,
        'page_type': pageType,
        'page_type_ext': pageTypeExt,
        'click_data': clickData,
        'innter_page_time': inPageTime,
        'out_page_time': outPageTime,
        'loading_page_start_time': loadPageStartTime,
        'loading_page_end_time': loadPageEndTime,
        'page_click_time': pageClickTime,
        'ext': ext
      }
      return data
    },
    // 识别码2
    fingerprintCode () {
      return window.fingerprintDo()
    },
    // 识别码
    IdentificationCode (requesttType = '') {
      const navigatorInfo = {
        canvasData: this.common.canvasFingerprint(),
        userAgent: window.navigator.userAgent,
        platform: window.navigator.platform,
        language: window.navigator.language,
        hardwareConcurrency: window.navigator.hardwareConcurrency,
        vendor: window.navigator.vendor,
        numberingSystem: Intl.DateTimeFormat().resolvedOptions().numberingSystem,
        timeZone: Intl.DateTimeFormat().resolvedOptions().timeZone,
        width: window.screen.width,
        height: window.screen.height,
        plugins: this.common.getPluginsInfo(window.navigator.plugins),
        // connection: this.common.getConnectionInfo(window.navigator.connection),
        WebGL: this.common.generateWebGLFingerprint(),
        webFont: this.common.webFont()

        // appVersion: window.navigator.appVersion,
        // appName: window.navigator.appName,
        // appCodeName: window.navigator.appCodeName,
        // languages: window.navigator.languages,
        // cookieEnabled: window.navigator.cookieEnabled,
        // doNotTrack: window.navigator.doNotTrack,
        // onLine: window.navigator.onLine,
        // geolocation: window.navigator.geolocation,
        // mediaDevices: window.navigator.mediaDevices,
        // vendorSub: window.navigator.vendorSub,
        // product: window.navigator.product,
        // productSub: window.navigator.productSub,
        // userAgentData: window.navigator.userAgentData,
        // mimeTypes: this.getMimeTypesInfo(window.navigator.mimeTypes),
        // maxTouchPoints: window.navigator.maxTouchPoints,
        // clipboard: this.getClipboardInfo(window.navigator.clipboard)
      }

      // 拼接字符串
      var navigatorInfoConcat = this.common.concatenateValues(navigatorInfo)
      var navigatorInfoMd5 = this.$md5(navigatorInfoConcat)
      // console.log(navigatorInfoMd5)
      var hashResultBase64 = btoa(navigatorInfoConcat).toString()
      // console.log(hashResultBase64)

      if (requesttType === 'MD5') {
        return navigatorInfoMd5
      }
      return hashResultBase64
    },
    // 追踪页面访问事件
    trackPageView (page) {
      var innterPageTime = parseInt(new Date().getTime())
      var data = {
        'page': page,
        'page_source': '',
        'type': 'pageview',
        'request': '', // 请求
        'result': '', // 结果
        'response': '', // 返回
        'pageType': 'inpage', // 操作的数据
        'pageTypeExt': '', // 操作的数据值
        'innterPageTime': innterPageTime,
        'outPageTime': '',
        'loadPageStartTime': '',
        'loadPageEndTime': '',
        'ext': ''
      }
      var params = this.commonParam(data, 'in')
      var paramsThicken = this.common.encryptionData(params, this)
      this.sendEventData(paramsThicken)
    },
    // 页面加载完成记录
    loadPageView (request, response, requestTime, responseTime, pageTypeExt = '') {
      var data = {
        'page': '',
        'page_source': '',
        'type': 'pageview',
        'request': request, // 请求
        'result': response.flag, // 结果
        'response': response, // 返回
        'pageType': 'loaded', // 操作的数据
        'pageTypeExt': pageTypeExt, // 操作的数据值
        'innterPageTime': '',
        'outPageTime': '',
        'loadPageStartTime': requestTime,
        'loadPageEndTime': responseTime,
        'ext': ''
      }
      var params = this.commonParam(data, 'data')
      var paramsThicken = this.common.encryptionData(params, this)
      this.sendEventData(paramsThicken)
    },
    // 点击操作 触发的方法
    clickPageAction (pageType, pageTypeExt = '', data = {}, request = {}, response = {}) {
      var pageClickTime = parseInt(new Date().getTime())
      var buttonData = {
        'page': '',
        'page_source': '',
        'type': 'button',
        'request': request, // 请求
        'result': response.flag, // 结果
        'response': response, // 返回
        'pageType': pageType, // 操作的数据
        'pageTypeExt': pageTypeExt, // 操作的数据值
        'clickData': data,
        'pageClickTime': pageClickTime,
        'ext': ''
      }
      var params = this.commonParam(buttonData, 'data')
      var paramsThicken = this.common.encryptionData(params, this)
      this.sendEventData(paramsThicken)
    },
    // 关闭网页触发 方法
    closePage (operateType) {
      // 如果已经提交过数据，则不执行下面的操作
      var isSubmitting = localStorage.getItem('isSubmitting')
      if (isSubmitting) {
        return
      }
      // 存储标记值
      localStorage.setItem('isSubmitting', true)

      var pageCloseTime = parseInt(new Date().getTime())
      var data = {
        'page_source': '',
        'type': 'pageview',
        'request': operateType, // 请求
        'result': '', // 结果
        'response': '', // 返回
        'pageType': 'outpage', // 操作的数据
        'pageTypeExt': '', // 操作的数据值
        'inPageTime': '',
        'outPageTime': pageCloseTime,
        'loadPageStartTime': '',
        'loadPageEndTime': '',
        'ext': ''
      }

      var params = this.commonParam(data, 'out')
      var paramsThicken = this.common.encryptionData(params, this)
      this.sendEventData(paramsThicken)
    },
    // 发送事件数据到服务器
    sendEventData (data) {
      const xhr = new XMLHttpRequest()

      xhr.open('POST', '/api/webBuryPoint')
      xhr.setRequestHeader('Content-Type', 'application/json')

      xhr.onload = function () {
        localStorage.removeItem('isSubmitting')
      }
      xhr.onerror = function () {
        localStorage.removeItem('isSubmitting')
      }

      xhr.send(JSON.stringify(data))
    },
    // send google数据
    sendGoogleAnalysis () {
      window.dataLayer = window.dataLayer || []
      // console.log(arguments)
      window.dataLayer.push(arguments)
    }
  }
}

export default webBuryPoint



// WEBPACK FOOTER //
// ./src/util/webBuryPoint.js